import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {AcabimResource, BimDataModel, BimModelService, ProjectApiService} from '@cas-hub/acabim-common-client';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {DataExportRequest} from '../../../../_models/data-export.model';
import {DataExportService} from '../../../../_services/data-export.service';

@Component({
    selector: 'acabim-admin-create-export-request',
    templateUrl: './create-export-request.component.html',
    styleUrls: ['./create-export-request.component.scss']
})
export class CreateExportRequestComponent implements OnInit, OnDestroy {

    @Output() public dataExportRequestCreated = new EventEmitter<DataExportRequest>();

    public selectedModel?: AcabimResource;

    public get models(): AcabimResource[] {
        return this._models;
    }

    private _models: AcabimResource[] = [];
    private readonly _unsubscribe = new Subject<void>();

    constructor(public readonly projectApiService: ProjectApiService,
                public readonly bimDataModelService: BimModelService,
                public readonly dataExportService: DataExportService) { }

    public ngOnInit(): void {
        this.projectApiService.selectedProjectId$.pipe(takeUntil(this._unsubscribe))
            .subscribe(projectId => {
                if (projectId) {
                    this.bimDataModelService.getBimModels(projectId, undefined).subscribe(models => this.setBimModels(models), error => {
                        this.setBimModels([]);
                    });
                } else {
                    this.setBimModels([]);
                }
            });
    }

    public startExport(): void {
        if (this.selectedModel) {
            this.dataExportService.startBuildingDataExport(this.selectedModel.id).subscribe(req => this.dataExportRequestCreated.emit(req));
        }
    }

    public ngOnDestroy(): void {
        this._unsubscribe.next();
        this._unsubscribe.complete();
    }

    private setBimModels(models: BimDataModel[]): void {
        const displayName = (model: BimDataModel): string => {
            let result = '';
            if (model.modelName) {
                result += `${model.modelName} - `;
            }

            result += model.modelId;
            result += ` [${model.modelType}]`;

            if (model.isDefault) {
                result += ' (Default)';
            }

            return result;
        };

        if (models && models.length) {
            this._models = [];
            models.forEach(model => this._models.push({id: model.modelId, name: displayName(model), lastModifiedDate: model.createdDate}));
            this.selectedModel = this.models[0];
        } else {
            this._models = [];
            this.selectedModel = undefined;
        }
    }
}
